import { render, staticRenderFns } from "./terminatePartition.vue?vue&type=template&id=70d612a3&scoped=true"
import script from "./terminatePartition.vue?vue&type=script&lang=ts"
export * from "./terminatePartition.vue?vue&type=script&lang=ts"
import style0 from "./terminatePartition.vue?vue&type=style&index=0&id=70d612a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d612a3",
  null
  
)

export default component.exports